import { apiGet, apiDelete, apiPost, API_PATH } from "../api/client";
import type { DeviceDto } from "../store/devices.store";

export const DevicesService = {
  async getDevices(): Promise<DeviceDto[]> {
    return apiGet<DeviceDto[]>(`${API_PATH}/devices`);
  },

  async removeDevice(
    deviceId: number,
  ): Promise<{ status: string; message: string }> {
    return apiDelete<{ status: string; message: string }>(
      `${API_PATH}/devices/${deviceId}/access`,
    );
  },

  async logoutDevice(
    deviceId: number,
  ): Promise<{ status: string; message: string }> {
    return apiPost<{ status: string; message: string }>(
      `${API_PATH}/devices/${deviceId}/logout`,
    );
  },
};
